import { Component, inject, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { GetOrdersByStoreIdParams, OrderService } from 'app/back-office/shared/services/back-office/order.service';
import { OrderMapper } from 'app/back-office/shared/utilities/order-mapper';
import { ShopContextStore } from 'app/shared/state/shop-context.store';

@Component({
    selector: 'app-order-filter',
    templateUrl: './order-filter.component.html',
    styleUrls: ['./order-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderFilterComponent implements OnInit, OnChanges {
  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;
  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search order...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [new FilterItem({ text: 'STATUS.ALL', value: null })];

  private _shopContext = inject(ShopContextStore);

  constructor(
    private _orderService: OrderService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 1) {
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }

  onSearch(search: string) {
    this.searchValue = search;
    if (search === '') this.dataToView = [new FilterItem({ text: 'STATUS.ALL', value: null })];
    this.setDataToView(0);
  }

  setDataToView(skipCount: number) {
    const storeId = this._shopContext.currentShop().id;
    const filters: GetOrdersByStoreIdParams = {
      storeId,
      searchString: this.searchValue,
      skipCount,
      maxResultCount: 20,
    };

    this._orderService.getOrdersByStoreId(this.loaderId, filters).subscribe(res => {
      this.dataToView = res.items.map(el => FilterMapper.OrderFilter(OrderMapper.OrderVm(el)));
      this.totalCount = res.totalCount + 1;
    });
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }

}
